<script>
	import { slide } from 'svelte/transition'

	export let message
	export let timeout_ms = 5000
	let timeout_handle = null

	$: {
		if (message) {
			if (timeout_handle) {
				clearTimeout(timeout_handle)
			}
			timeout_handle = setTimeout(() => {
				message = null // this purposely has side-effects for the parent template
			}, timeout_ms)
		}
	}
</script>

{#if message}
	<div class="message {message.type}" transition:slide|global>{message.text}</div>
{/if}

<style>
	.message {
		padding: 0;
		font-weight: 400 !important;
		color: #fff;
	}

	.error {
		padding: 5px 10px;
		background: #a90707;
		color: #fff;
	}

	.success {
		padding: 5px 10px;
		background: #ceff51;
		color: #000;
	}
</style>
